import { modalTypes as m } from '../../context/types';

const modalContent = {
  [m.documentInfo]: {
    icon: 'InfoIcon',
    header: '¡Importante!',
    text: 'Para comenzar necesitamos validar tu identidad. Por favor, tené a mano tu DNI.',
    button: {
      text: 'Aceptar',
      action: 'close',
    },
  },
  [m.documentRetry]: {
    icon: 'RetryIcon',
    header: '¡No pudimos validar tu documento!',
    text: 'No pudimos procesar la información correctamente. Intenta nuevamente',
    button: {
      text: 'Reintentar',
      action: 'retry',
    },
  },
  [m.signatureInfo]: {
    icon: 'InfoIcon',
    header: '¡Importante!',
    text: 'Para tomarte la selfie te recomendamos: ',
    list:[
      ' Buscar un lugar luminoso y con fondo claro.',
      ' Necesitamos que la foto no tenga reflejos de luz.'
    ],
    button: {
      text: 'Aceptar',
      action: 'close',
    },
  },
  [m.selfieSpecialInfo]: {
    icon: 'InfoIcon',
    header: '¡Muy bien!',
    text: 'Ahora necesitamos que te tomes una ultima selfie con un gesto.',
    button: {
      text: 'Aceptar',
      action: 'close',
    },
  },
  [m.signatureSuccess]: {
    icon: 'SuccessIcon',
    header: '¡La firma electrónica se realizó correctamente!',
    text: 'Ahora debes verificar tus datos para terminar el proceso.',
    button: {
      text: 'Aceptar',
      action: 'next',
    },
  },
  [m.signatureRetry]: {
    icon: 'RetryIcon',
    header: '¡No pudimos validar tu firma electrónica!',
    text: 'Necesitamos que vuelvas a intentarlo. No pudimos procesar la información correctamente.',
    button: {
      text: 'Reintentar',
      action: 'retry',
    },
  },
  [m.formSuccess]: {
    icon: 'SuccessIcon',
    header: '¡Cambios Guardados!',
    text: 'Los cambios que realizaste se guardaron de manera exitosa. Vamos a contactarnos con vos a la brevedad.',
    button: {
      text: 'Aceptar',
      action: 'close',
    },
  },
  [m.formRetry]: {
    icon: 'RetryIcon',
    header: '¡Cambios no guardados!',
    text: 'Los datos dirección, código postal, telefono y email son necesarios',
    button: {
      text: 'Reintentar',
      action: 'retry',
    },
  },
  [m.failure]: {
    icon: '',
    header: '',
    text: '',
    button: {
      text: '',
      action: '',
    },
  },
  [m.otpFailed]: {
    icon: 'RetryIcon',
    header: '¡Algo ha salido mal!',
    text: 'La contraseña ingresada es incorrecta',
    button: {
      text: 'Reintentar',
      action: 'retry',
    },
  },
  [m.documentFailed]: {
    icon: 'RetryIcon',
    header: '¡Algo ha salido mal!',
    text: 'El documento ingresado no corresponde a la operación',
    button: {
      text: 'Reintentar',
      action: 'retry',
    },
  },
  [m.loginSuccess]: {
    icon: 'SuccessIcon',
    header: '¡Usted ha ingresado correctamente!',
    text: 'Ahora podrás realizar tu firma electrónica',
    button: {
      text: 'Aceptar',
      action: 'close',
    },
  },
};

export default modalContent;
